import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const sendUserInvitation = createApiThunk<void, string>(
  "users/sendUserInvitation",
  async (userId: string, { extra: { adminRepository } }) => {
    return adminRepository!.sendUserInvitation(userId);
  },
);

export const resetSendUserInvitation = createAction("users/resetSendUserInvitation");
